import API from '../api'
import deleteUrl from './paths'

const deleteFactoryInvoiceApi = (orderId, userId, invoiceNumber) =>
    new Promise((resolve, reject) => {
        API.delete(deleteUrl.deleteFactoryInvoice, { orderId, userId, invoiceNumber })
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => reject(err))
    })

export { deleteFactoryInvoiceApi }
